<template>
	<footer id="main-footer">
		Copyright &copy; 2020
	</footer>
</template>

<script>
	export default {
		name: 'Footer'
	}
</script>